import React from 'react'

import { LazyLoadImage } from 'react-lazy-load-image-component'
import 'react-lazy-load-image-component/src/effects/blur.css'

import {
  PostBoxStyled,
  PostBoxMediaStyled,
  PostBoxDateStyled,
  PostBoxCategoryStyled,
  PostBoxTitleStyled,
  PostBoxContentStyled,
  PostBoxContainerStyled
} from './styles'
import { PostBoxProps } from './types'

const PostBox: React.FC<PostBoxProps> = ({ isShortened, url, image, alt, date, category, title, content, withoutMedia, isPrimary }) => {
  return (
    <PostBoxStyled to={url}>
      <PostBoxMediaStyled {...{ withoutMedia, isPrimary }}>
        {image && <LazyLoadImage src={image} alt={alt ? alt : title} width="100" height="100" effect="blur" />}
      </PostBoxMediaStyled>
      <PostBoxContainerStyled>
        {date && <PostBoxDateStyled>{date}</PostBoxDateStyled>}
        {category && !isShortened && <PostBoxCategoryStyled>{category}</PostBoxCategoryStyled>}
        <PostBoxTitleStyled>{title}</PostBoxTitleStyled>
        {content && !isShortened && <PostBoxContentStyled dangerouslySetInnerHTML={{ __html: content }} />}
      </PostBoxContainerStyled>
    </PostBoxStyled>
  )
}

export default PostBox
